import React from 'react';

interface WarningProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'className'> {
    className?: string;
    children?: React.ReactNode;
}

const Warning: React.FC<WarningProps> = ({ className = '', children, ...props }) => {
    return (
        <div className={`idsk-warning-text ${className}`.trim()} {...props}>
            <div className="govuk-width-container">
                <div className="idsk-warning-text__text">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default Warning;
